import React from 'react'
import { Button } from 'antd'
import Card from '../Card'
import { CheckCircleOutlined } from '@ant-design/icons'
import $t from '../../../i18n'

import './SpecialityServiceCard.css'

const SpecialityServiceCard = props => {
  const {
    title,
    image,
    buttonText,
    onContinue,
    showDisclaimer,
    descriptionTitle,
    descriptionNotes,
    descriptionPointsTitle,
    descriptionPoints,
    hidden,
    displayCheckedAction,
  } = props

  const renderDescriptionTitle = () => <div>{descriptionTitle}</div>

  const renderDescriptionPoints = () => {
    return descriptionPoints.map((eachPoint, i) => (
      <div key={i} className="desc-pointer-container">
        <div className="point-marker"></div>
        <div>{eachPoint}</div>
      </div>
    ))
  }

  return (
    <Card
      className={
        props.hidden
          ? 'speciality-service-card-container hidden'
          : 'speciality-service-card-container'
      }
    >
      <img className="service-icon" alt="" src={image} />
      <span className="service-title">{title}</span>
      <div className="service-description-container">
        {renderDescriptionTitle()}
        <br />
        <div className="description-points-container">
          {descriptionNotes ? descriptionNotes : null}
          {descriptionNotes ? <br /> : null}
          {descriptionPointsTitle ? descriptionPointsTitle : null}
          <br />
          {renderDescriptionPoints()}
        </div>
      </div>
      <Button
        className="service-button"
        disabled={displayCheckedAction}
        onClick={onContinue}
        type="primary"
        icon={displayCheckedAction ? <CheckCircleOutlined /> : <div />}
      >
        {buttonText}
      </Button>
      <span className="service-disclaimer" data-hidden={!showDisclaimer}>
        {$t('pages.getStarted.specialityServices.disclaimer', {
          clinic: title,
        })}
      </span>
    </Card>
  )
}

export default SpecialityServiceCard
